import { BusinessUser } from '../api_types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const adminApi = {
  createBusinessUser: async (businessId: string, userData: {
    email: string;
    name: string;
    role: 'staff' | 'admin' | 'coach';
  }): Promise<BusinessUser> => {
    const response = await fetch(`${API_BASE_URL}/api/admin/businesses/${businessId}/users`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to create business user');
    }

    return response.json();
  },

  getBusinessUsers: async (businessId: string): Promise<BusinessUser[]> => {
    const response = await fetch(`${API_BASE_URL}/api/admin/businesses/${businessId}/users`);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to fetch business users');
    }

    return response.json();
  },

  deleteBusinessUser: async (businessId: string, userId: string): Promise<void> => {
    const response = await fetch(`${API_BASE_URL}/api/admin/businesses/${businessId}/users/${userId}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to delete business user');
    }
  },
}; 